import React from "react";
import LegalLayout from "@/components/site/LegalLayout";

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-outfit text-2xl md:text-3xl font-medium text-white">
      {title}
    </h2>
    <div className="space-y-3 text-white/70">{children}</div>
  </section>
);

export default function Confidentialite() {
  return (
    <LegalLayout
      kicker="RGPD"
      title="Politique de confidentialité"
    >
      <p>
        EM Group accorde une importance particulière à la protection de vos
        données personnelles. La présente politique décrit les données
        collectées via le site emgroupdigital.com, les finalités de leur
        traitement et vos droits en matière de protection de la vie privée.
      </p>

      <Section title="1. Responsable du traitement">
        <p>
          EM Group, 60 rue François 1<sup>er</sup>, 75008 Paris — contact{" "}
          <a
            href="mailto:contact@emgroupdigital.com"
            className="text-[#E52431] hover:underline"
          >
            contact@emgroupdigital.com
          </a>
          .
        </p>
      </Section>

      <Section title="2. Données collectées">
        <p>
          Nous collectons uniquement les données nécessaires à la bonne
          exécution de nos services :
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>
            <span className="text-white">Formulaire de devis :</span> nom,
            email, téléphone (facultatif), entreprise (facultative), type de
            projet, message.
          </li>
          <li>
            <span className="text-white">Chatbot Émi :</span> contenu des
            messages échangés, nom, email, WhatsApp et besoin lorsque vous
            choisissez de vous faire recontacter.
          </li>
          <li>
            <span className="text-white">Paiements :</span> les paiements
            sont traités par Stripe. Nous ne stockons jamais vos données
            bancaires.
          </li>
          <li>
            <span className="text-white">Données techniques :</span>{" "}
            identifiant de session, adresse IP (anonymisée), type de
            navigateur à des fins statistiques et de sécurité.
          </li>
        </ul>
      </Section>

      <Section title="3. Finalités du traitement">
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>Répondre aux demandes de devis et de contact.</li>
          <li>Fournir les prestations commandées.</li>
          <li>Assurer la relation client et le suivi des projets.</li>
          <li>Améliorer nos services et l&rsquo;expérience utilisateur.</li>
          <li>Respecter nos obligations légales et comptables.</li>
        </ul>
      </Section>

      <Section title="4. Base légale">
        <p>
          Les traitements reposent sur votre consentement (formulaires,
          chatbot), l&rsquo;exécution d&rsquo;un contrat (prestations
          commandées) et nos obligations légales (comptabilité, lutte contre
          la fraude).
        </p>
      </Section>

      <Section title="5. Durée de conservation">
        <p>
          Les données liées aux prospects sont conservées{" "}
          <span className="text-white">3 ans</span> à compter du dernier
          contact. Les données liées aux clients sont conservées pendant la
          durée nécessaire à la relation contractuelle puis archivées pour
          une durée de <span className="text-white">10 ans</span>{" "}
          (obligations comptables).
        </p>
      </Section>

      <Section title="6. Destinataires">
        <p>
          Vos données sont strictement destinées à EM Group et à ses
          sous-traitants techniques (hébergeur, Stripe pour le paiement,
          Resend pour l&rsquo;envoi d&rsquo;emails, fournisseur LLM pour le
          chatbot). Aucune donnée n&rsquo;est revendue à des tiers.
        </p>
      </Section>

      <Section title="7. Vos droits">
        <p>
          Conformément au Règlement Général sur la Protection des Données
          (RGPD) et à la loi Informatique et Libertés, vous disposez des
          droits suivants :
        </p>
        <ul className="list-disc pl-6 space-y-2 marker:text-[#E52431]">
          <li>Droit d&rsquo;accès à vos données.</li>
          <li>Droit de rectification.</li>
          <li>Droit à l&rsquo;effacement (« droit à l&rsquo;oubli »).</li>
          <li>Droit à la limitation du traitement.</li>
          <li>Droit à la portabilité.</li>
          <li>Droit d&rsquo;opposition.</li>
          <li>Droit d&rsquo;introduire une réclamation auprès de la CNIL.</li>
        </ul>
        <p>
          Pour exercer ces droits, écrivez-nous à{" "}
          <a
            href="mailto:contact@emgroupdigital.com"
            className="text-[#E52431] hover:underline"
          >
            contact@emgroupdigital.com
          </a>
          . Nous vous répondrons sous 30 jours.
        </p>
      </Section>

      <Section title="8. Cookies">
        <p>
          Le Site utilise uniquement les cookies strictement nécessaires à
          son fonctionnement (session, préférences). Aucun cookie publicitaire
          ou de tracking tiers n&rsquo;est déposé sans votre consentement
          explicite.
        </p>
      </Section>

      <Section title="9. Sécurité">
        <p>
          Nous mettons en œuvre des mesures techniques et organisationnelles
          appropriées pour protéger vos données contre tout accès non
          autorisé, perte, altération ou divulgation&nbsp;: chiffrement HTTPS,
          accès restreint, sauvegardes régulières.
        </p>
      </Section>
    </LegalLayout>
  );
}
